import SimpleModal from '../modal/SimpleModal';

class MobileMenu {
  private buttons: NodeListOf<HTMLButtonElement>;
  private modal: SimpleModal;
  private activeMenu = '';

  constructor() {
    this.init();
  }

  private init(): void {
    this.buttons = document.querySelectorAll('.js-mobile-menu');
    const modalEl: HTMLElement = document.querySelector(
      '.js-mobile-menu-modal'
    );

    if (modalEl) this.modal = new SimpleModal(modalEl, true, false);
    if (this.buttons) this.events();
  }

  private events(): void {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        const { mobileMenu } = button.dataset;
        this.toggleModal(mobileMenu);
        this.toggleMenu(mobileMenu);
      });
    });
  }

  private toggleMenu(menu: string): void {
    document.body.dataset.mobileMenu = menu;
    if (this.modal.openStatus) {
      document.body.classList.add('mobile-menu--open');
      document.body.classList.remove('hide-menu');
      setTimeout(() => {
        document.body.classList.add('mobile-menu--blue');
      }, 350);
    } else {
      document.body.classList.remove('mobile-menu--open');
      document.body.classList.remove('mobile-menu--blue');
    }
  }

  private toggleModal(menu: string): void {
    if (!this.modal.openStatus && menu !== 'main') {
      this.modal.openModal();
      document.body.classList.remove('hide-menu');
    } else {
      // do
    }
  }
}

export default MobileMenu;
